var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappTemplateQuickReplyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.683,
    height: 21.232,
    viewBox: "0 0 22.683 21.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "reply",
    d: "M8.2,24.524V19.7L0,27.9l8.2,8.2V31.28c6.756,0,11.1,0,14.477,9.653C22.681,36.108,23.164,24.524,8.2,24.524Z",
    transform: "translate(0 -19.7)",
    fill: "#00a5f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappTemplateQuickReplyIcon);
export default __webpack_public_path__ + "static/media/whatsapp-template-quick-reply-icon.4429feae2c2a6d6fc74791c8905e6d66.svg";
export { ForwardRef as ReactComponent };